import { SessionsAPI } from "../infrastructure/api/sessions.api";
import type { SessionListParams } from "../domain/ISessionRepository";

/**
 * Session operations `sessionService` does not cover. Each returns the
 * response's data, so screens never handle an HTTP response.
 */

/** Finish a reviewed session the therapist chose not to have analyzed. */
export async function completeSessionReview(sessionId: string) {
    const { data } = await SessionsAPI.completeReview(sessionId);
    return data;
}

/**
 * The therapist has written a draft's notes. It waits for its analysis, or is
 * completed with the reason when no analysis can be asked for — the server
 * decides, never the client.
 */
export async function settleWrittenNotes(sessionId: string) {
    const { data } = await SessionsAPI.settleNotes(sessionId);
    return data;
}

export async function listLiveInsights(sessionId: string) {
    const { data } = await SessionsAPI.get_live_insights(sessionId);
    return data;
}

/** Upload a picture of handwritten notes; the session comes back with their text. */
export async function uploadSessionNotes(sessionId: string, form: FormData) {
    const res = await SessionsAPI.upload_notes(sessionId, form);
    return res?.data;
}

export async function listGroupPatientSessions(groupPatientId: string, params?: SessionListParams) {
    const { data } = await SessionsAPI.list_by_group_patient(groupPatientId, params);
    return data;
}
